import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FavoriteRoute } from '../../../interfaces/favorites/favorite-route.interface';
import { FavoriteLine } from '../../../interfaces/favorites/favorite-line.interface';

@Component({
    selector: 'app-favorite-line',
    templateUrl: './favorite-line.component.html',
    styleUrls: ['./favorite-line.component.scss'],
    standalone: false
})
export class FavoriteLineComponent {
  @Output() onEditButtonClick = new EventEmitter<void>();
  @Output() onDeleteButtonClick = new EventEmitter<void>();
  @Output() onPickFavoriteClick = new EventEmitter<void>();

  @Input() showActionButtons: boolean = false;
  @Input() line: FavoriteLine;
  /** a11y: accessible names for the pen/trash icon buttons (audit). */
  @Input() editAriaLabel: string = '';
  @Input() deleteAriaLabel: string = '';
}
